import React, { useState } from "react";
import "./WinGoModal.css";
import Winner_Modal from "../Winner_Modal/Winner_Modal";
import Looser_Modal from "../Looser_Modal/Looser_Modal";
import Successfull_strip_modal from "../Successfull_strip_modal/Successfull_strip_modal";

const WinGoModal = ({ selectedValue, type, onClose }) => {

  const [showSuccess, setShowSuccess] = useState(false);
  const [showWinner, setShowWinner] = useState(false);

  const [balance, setBalance] = useState(1);
  const [multiplier, setMultiplier] = useState(1);
  const [quantity, setQuantity] = useState(1);

  const themeColors = {
    violet:
      "linear-gradient(158deg, rgba(234,4,2,1) 0%, rgba(234,4,2,1) 33%, rgba(140,51,207,1) 69%, rgba(140,51,207,1) 100%)",
    green: "#44A841",
    red: "#EA0402",
    orange: "#F9A956",
    blue: "#6CA5F1",
  };

  const activeColor = themeColors[type] || themeColors.red;

  const handleConfirm = () => {

    // show success strip
    setShowSuccess(true);

    // after 3 sec hide success and show winner
    setTimeout(() => {
      setShowSuccess(false);
      setShowWinner(true);
    }, 3000);
  };

  return (
    <>
      <section
        className="wingo-modal-wrapper"
        style={{ "--primary-color": activeColor }}
      >
        <div className="wingo-overlay" onClick={onClose}>
          <div className="wingo-container" onClick={(e) => e.stopPropagation()}>

            <div className="wingo-header">
              <h2 className="wingo-title">Win Go 30 Second</h2>
              <div className="wingo-selection">Select {selectedValue}</div>
              <div className="wingo-arrow-down"></div>
            </div>

            <div className="wingo-body">

              <div className="wingo-row">
                <span className="wingo-label">Balance</span>
                <div className="wingo-btn-group">
                  {[1, 10, 100, 1000].map((v) => (
                    <button
                      key={v}
                      className={balance === v ? "active" : ""}
                      onClick={() => setBalance(v)}
                    >
                      {v}
                    </button>
                  ))}
                </div>
              </div>

              <div className="wingo-row">
                <span className="wingo-label">Quantity</span>
                <div className="wingo-counter">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>−</button>
                  <input type="text" value={quantity} readOnly />
                  <button onClick={() => setQuantity(quantity + 1)}>+</button>
                </div>
              </div>

              <div className="wingo-multipliers">
                {[1, 5, 10, 20, 50, 100].map((m) => (
                  <button
                    key={m}
                    className={multiplier === m ? "active" : ""}
                    onClick={() => setMultiplier(m)}
                  >
                    X{m}
                  </button>
                ))}
              </div>

              <div className="wingo-agreement">
                <input type="checkbox" defaultChecked />
                <label>
                  I Agree <span className="wingo-link">« Pre-sale rules »</span>
                </label>
              </div>

            </div>

            <div className="wingo-footer">
              <button className="wingo-btn-cancel" onClick={onClose}>
                Cancel
              </button>

              <button className="wingo-btn-confirm" onClick={handleConfirm}>
                Total Amount ₹{(balance * quantity * multiplier).toFixed(2)}
              </button>
            </div>

          </div>
        </div>
      </section>


      {/* Success Strip */}
      <Successfull_strip_modal
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
        textMsg="Bet Placed Successfully!"
      />

      {/* Winner Modal */}
      <Winner_Modal
        show={showWinner}
        onHide={() => setShowWinner(false)}
      />

    </>
  );
};

export default WinGoModal;